import { gql } from 'graphql-request';

import type { RequestDocument } from 'graphql-request';

export const TRANSLATION_HANDLER_QUERY_FRAGMENT = gql`
  {
    id
    label
    internalName
    description
    provider
    defaultModel {
      id
      internalName
      displayName
      modelId
    }
    isDefault
    isActive
  }
`;

export const ALL_TRANSLATION_HANDLERS_QUERY: RequestDocument = gql`
  query {
    allTranslationHandlers(first: 100, filter: { isActive: { eq: true } }) ${TRANSLATION_HANDLER_QUERY_FRAGMENT}
  }
`;

export const TRANSLATION_HANDLER_BY_INTERNAL_NAME_QUERY: RequestDocument = gql`
  query getTranslationHandler($internalName: String!) {
    translationHandler(filter: { internalName: { eq: $internalName } }) ${TRANSLATION_HANDLER_QUERY_FRAGMENT}
  }
`;
